// extracted by mini-css-extract-plugin
export default {"container":"ShippingSection_container__cftVP","messageSection":"ShippingSection_messageSection__rvlXo"};